<template>
  <div class="full-screen-background">
  <v-container class="pa-4 fill-height">
    <v-row align="center" justify="center">


      <!-- Formulário de Login -->
      <v-col cols="12" sm="8" md="4">
        <h1 class="mb-4 text-center">{{ t('login.textCredenciais') }}</h1>
        <v-form @submit.prevent="onSubmit">
          <v-text-field
            v-model="mid"
            :label="t('login.acessLogin')"
            required
            @input="clearError"
          />
          <v-text-field
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            :label="t('login.acessPassword')"
            required
            :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-inner="toggleShowPassword"
            @input="clearError"
          />
          <v-checkbox
            v-model="remember"
            :label="t('login.lembrarSenha')"
            class="mt-2"
          />
          <v-alert
            v-if="errorMsg"
            type="error"
            dense
            outlined
            class="mt-4"
          >
            {{ errorMsg }}
          </v-alert>
          <v-row justify="center" class="mt-2">
            <RouterLink :to="{ name: 'ForgotPassword' }" class="text--primary">
              {{ t('login.forgotPass') }}
            </RouterLink>
          </v-row>

          <!-- reCAPTCHA -->
          <div ref="recaptcha" class="mt-4"></div>

          <div class="text-center mt-4">
            <v-btn type="submit" color="red">{{ t('login.Enter') }}</v-btn>
          </div>
        </v-form>
      </v-col>

     
    </v-row>

    <!-- Modal para inserir apelido (mid_surname) -->
    <v-dialog v-model="showSurnameModal" persistent max-width="400px">
      <v-card>
        <v-card-title class="headline">{{ t('login.escolhaApelido') }}</v-card-title>
        <v-card-text>
          <p>
            {{ t('login.descApelido') }}
          </p>
          <v-text-field
            v-model="surname"
            label="Apelido de exibição"
            required
            @input="clearError"
          />
          <v-alert
            v-if="errorMsg"
            type="error"
            dense
            outlined
            class="mt-2"
          >
            {{ errorMsg }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="saveSurname">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
  </div>
</template>

<script setup>
 import { useI18n } from 'vue-i18n'
 const { t } = useI18n()
import { ref, onMounted, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { login, updateSurname } from '../services/api';
import { saveAuth } from '../auth';


const router            = useRouter();
const mid               = ref('');
const password          = ref('');
const remember          = ref(false);
const showPassword      = ref(false);
const errorMsg          = ref('');
const recaptcha         = ref(null);
let widgetId            = null;

// estados para o modal de apelido
const showSurnameModal  = ref(false);
const surname           = ref('');

function toggleShowPassword() {
  showPassword.value = !showPassword.value;
}
function clearError() {
  errorMsg.value = '';
}

// espera o grecaptcha carregar
function waitForRecaptcha() {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(new Error('Timeout ao carregar reCAPTCHA')), 5000);
    const interval = setInterval(() => {
      if (window.grecaptcha) {
        clearTimeout(timeout);
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });
}

onMounted(async () => {
  // preencher mid/password se "remember" estava ativo
  const sm = localStorage.getItem('mid');
  const sp = localStorage.getItem('password');
  if (sm && sp) {
    mid.value = sm;
    password.value = sp;
    remember.value = true;
  }

  // render do reCAPTCHA
  await nextTick();
  try {
    await waitForRecaptcha();
    window.grecaptcha.ready(() => {
      if (recaptcha.value) {
        widgetId = window.grecaptcha.render(recaptcha.value, {
          sitekey: '6LctjCgrAAAAAAf882WomVgYZcZ3BsH_ntZJpl0C',
          theme: 'light'
        });
      } else {
        console.error('Container reCAPTCHA não encontrado.');
      }
    });
  } catch (err) {
    console.error('Erro ao carregar reCAPTCHA:', err);
    errorMsg.value = 'Erro ao carregar reCAPTCHA. Recarregue a página.';
  }
});

async function onSubmit() {
  clearError();

  // validação reCAPTCHA
  if (widgetId === null) {
    errorMsg.value = 'Captcha indisponível. Recarregue a página.';
    return;
  }
  const captchaResponse = window.grecaptcha.getResponse(widgetId);
  if (!captchaResponse) {
    errorMsg.value = 'Por favor, confirme que não é um robô.';
    return;
  }

  // armazenamento “lembrar”
  if (remember.value) {
    localStorage.setItem('mid', mid.value);
    localStorage.setItem('password', password.value);
  } else {
    localStorage.removeItem('mid');
    localStorage.removeItem('password');
  }

  // tentativa de login
  try {
    const res = await login(mid.value, password.value, captchaResponse);
    saveAuth(res.token, res.user);
    localStorage.setItem('jwt_token', res.token);

    // se não tiver mid_surname, abre modal
    if (!res.user.mid_surname) {
      showSurnameModal.value = true;
      return;
    }

    // segue para home
    router.push({ name: 'Home' });
  } catch (err) {
    console.error(err);
    errorMsg.value = err.message || 'Erro ao conectar. Tente novamente.';
    window.grecaptcha.reset(widgetId);
  }
}

async function saveSurname() {
  clearError();
  if (!surname.value || surname.value.length < 2) {
    errorMsg.value = 'Apelido muito curto.';
    return;
  }
  try {
    const token = localStorage.getItem('jwt_token');
    // chama o endpoint sem atribuir a uma variável não usada
    await updateSurname(token, surname.value);
    showSurnameModal.value = false;
    router.push({ name: 'Home' });
  } catch (err) {
    console.error(err);
    errorMsg.value = err.message || 'Não foi possível salvar apelido.';
  }
}
</script>

<style scoped>
.login-img {
  display: block;
  width: 150%;
  max-width: 200px;
  height: auto;
}
.full-screen-background {
  background-image: url('@/assets/background/cassino/cassinoz.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}

</style>
